// src/request/api/dict/getAllUpgrades.ts

import {WeaponUpgradeFullDto} from "../../../../model/Dto/Dict/WeaponUpgrade";
import {ApiRequest, RequestMethod} from "../../../request";

const URL = "/api/weapon-upgrade";

export async function getAllUpgrades(): Promise<WeaponUpgradeFullDto[]> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.GET);
    apiRequest.setUrl(URL);

    const response: any = await apiRequest.send();

    return response.data.map((upgrade: any) => ({
        id: upgrade["id"],
        name: upgrade["name"],
        description: upgrade["description"],
        price: upgrade["price"],
        rarity: upgrade["rarity"],
        prices: upgrade["prices"] ? {
            firstCategory: upgrade["prices"]["firstCategory"],
            secondCategory: upgrade["prices"]["secondCategory"],
            thirdCategory: upgrade["prices"]["thirdCategory"],
            fourthCategory: upgrade["prices"]["fourthCategory"],
            fifthCategory: upgrade["prices"]["fifthCategory"],
        } : null,
        enum: upgrade["enum"],
        commonStatus: upgrade["commonStatus"],
    }));
}